import { Boolean, Dictionary, Literal, Partial, Record, String, Undefined } from "runtypes";
import { clean } from "./clean";
import { PERSONABLE_PROFILE_COLLECTION } from "./collections";
export const StaffProfile = Record({
  kind: Literal("staff"),
  netID: String,
  name: String,
  introductionVideo: String,
  tagline: String,
  bio: String,
  passion: String,
  goals: String
}).And(
  Partial({
    gender: String,
    website: String
  })
);
export const StudentProfile = Record({
  kind: Literal("student"),
  netID: String,
  name: String,
  introductionVideo: String,
  highSchool: Dictionary(Boolean),
  bio: String,
  interest: String,
  goals: String
}).And(
  Partial({
    gender: String,
    data: String,
    programmingAbility: String,
    accommodations: String,
    hispanic: String,
    race: Dictionary(Boolean),
    illinois: String,
    illinoisPromise: String,
    parentsCollege: String
  })
);
export const Profile = StudentProfile.Or(StaffProfile);
export const GENDER_OPTIONS = [
  { value: "female", description: "she, her, hers" },
  { value: "male", description: "he, him, his" },
  { value: "other", description: "they, them, theirs" }
];
export const PRIOR_OPTIONS = [
  { value: "APCSA", description: "I took AP Computer Science A" },
  { value: "APCSP", description: "I took AP Computer Science Principles" },
  { value: "java", description: "I took a course in Java" },
  { value: "python", description: "I took a course in Python" },
  { value: "other", description: "I took a computer science course" },
  { value: "learncsonline", description: "I reviewed the materials on learncs.online" }
];
export const RACE_OPTIONS = [
  { value: "nativeAmerican", description: "American Indian or Alaska Native" },
  { value: "asian", description: "Asian" },
  { value: "black", description: "Black or African American" },
  { value: "hawaiian", description: "Native Hawaiian or Other Pacific Islander" },
  { value: "white", description: "White" }
];
export const loadProfile = async (db, netID) => {
  return Profile.Or(Undefined).check(
    clean(await db.collection(PERSONABLE_PROFILE_COLLECTION).findOne({ netID, invalidated: { $exists: false } }))
  );
};
export const loadStudentProfile = async (db, netID) => {
  return StudentProfile.Or(Undefined).check(
    clean(
      await db.collection(PERSONABLE_PROFILE_COLLECTION).findOne({ netID, kind: "student", invalidated: { $exists: false } })
    )
  );
};
export const loadStaffProfile = async (db, netID) => {
  return StaffProfile.Or(Undefined).check(
    clean(
      await db.collection(PERSONABLE_PROFILE_COLLECTION).findOne({ netID, kind: "staff", invalidated: { $exists: false } })
    )
  );
};
//# sourceMappingURL=profile.js.map
